module.exports = __webpack_public_path__ + "img/mtl.af0a31c7.svg";